// GENERATED FILE - DO NOT MODIFY

export enum GetMessagesSortColumnDto {
    Title = "Title",
    Body = "Body",
    CreatedByUserName = "CreatedByUserName",
    Date = "Date",
    Type = "Type",
}